import { injectable } from "inversify";
import SedeRepository from "../../../domain/repositories/SedeRepository";
import SedeEntity from "../../../domain/entities/SedeEntity";

const _sedeTest: SedeEntity = {
    id: 1,
    name: "Punto de Venta Morato",
    address: "Cll 98a #69B-35",
    phone: "+57 324 4001212",
    photo: "",
    description: "",
    latitude: "4.7099272",
    longitude: "-74.0406181",
    active: true,
};

@injectable()
class SedeRepositoryDev implements SedeRepository {
    async getAll(): Promise<SedeEntity[]> {
        return [_sedeTest];
    }
}

export default SedeRepositoryDev;
